import API from '@/views/Fdc/Apis'
import ModelGrid from '@/views/Fdc/Detection/Components/ModelGrid'
import ModelConditionGrid from '@/views/Fdc/Detection/Components/ModelConditionGrid'
import LotsModal from '@/views/Fdc/Detection/Components/LotsModal'
import _ from 'lodash'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'
import Dayjs from 'dayjs'

/**
 * Detection > Set-Point Detection
 * Set-Point Detection Model 관리
 */
export default {
  name: 'SetPointDetection',
  components: {
    'model-grid': ModelGrid, // Detection Model Grid component
    'model-condition-grid': ModelConditionGrid, // Detection Model Condition Grid component
    'lots-modal': LotsModal // Select LOT Modal component
  },
  computed: {
  },
  // 해당 data변경
  watch: {
    /**
     * orgLotsList 변화 감지
     * @param {*} list original chart data
     */
    orgLotsList (list) {
      let max = 0
      for (let i in list) {
        if (list[i].stepRunTime > max) {
          max = list[i].stepRunTime
        }
      }
      this.maxStepRunTime = max
    }
  },
  mounted () {
    this.drawChartArea()
  },
  methods: {
    /**
     * 스플릿 패널 리사이즈 시 플라틀리 리사이즈
     * 윈도우 리사이즈 이벤트 생성해서 디스패치
     */
    splitPanesResized () {
      window.dispatchEvent(new Event('resize'))
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Detection Model 목록 조회
     */
    searchModel () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module ID']))
        return
      }

      this.searchTreeNode = this.selectedTreeNode

      this.$refs.modelGrid.searchModel()

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.clearData()
    },
    /**
     * AutoSpec Validation
     * @returns {Boolean} validation 성공 여부
     */
    isValidAutoSpec () {
      if (this.selectedModelData == null || !Object.keys(this.selectedModelData).length) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Model']))
        return false
      }
      if (this.selectedLots == null || this.selectedLots.length < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Lots']))
        return false
      }
      if (this.chartData == null || !this.chartData.length) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Chart Data']))
        return false
      }
      if (this.uslSig <= this.uclSig) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Upper Sigma']))
        return false
      }
      if (this.lslSig <= this.lclSig) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Lower Sigma']))
        return false
      }
      var isValid = function (that, sigma, name) {
        if (sigma == null || !sigma > 0) {
          that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [name + ' Sigma']))
          return false
        }
        if (sigma <= 0) {
          that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', [name + ' Sigma']))
          return false
        }
        return true
      }

      return !(!isValid(this, this.uslSig, 'USL') ||
      !isValid(this, this.uclSig, 'UCL') ||
      !isValid(this, this.lclSig, 'LCL') ||
      !isValid(this, this.lslSig, 'LSL'))
    },
    /**
     * Auto Spec 계산
     */
    async calcAutoSpec () {
      this.uslSig = Math.sqrt(Math.pow(this.uslSig, 2), 2)
      this.uclSig = Math.sqrt(Math.pow(this.uclSig, 2), 2)
      this.lclSig = Math.sqrt(Math.pow(this.lclSig, 2), 2)
      this.lslSig = Math.sqrt(Math.pow(this.lslSig, 2), 2)

      if (!this.isValidAutoSpec()) {
        return
      }

      const payload = {
        modelType: 'UVA',
        dataList: {
          uslSig: this.uslSig,
          uclSig: this.uclSig,
          lclSig: this.lclSig,
          lslSig: this.lslSig,
          paramName: this.selectedModelData.paramName,
          stepId: this.selectedModelData.stepId,
          chartValueList: this.lotsList
        }
      }

      const response = await API.Model.runSetPointAutoSpec(payload)
      if (response.status === 200) {
        this.meanVal = Math.round(response.data.mean * 10000) / 10000.0
        this.stdevVal = Math.round(response.data.stdev * 10000) / 10000.0
        this.uslVal = Math.round(response.data.usl * 10000) / 10000.0
        this.uclVal = Math.round(response.data.ucl * 10000) / 10000.0
        this.lclVal = Math.round(response.data.lcl * 10000) / 10000.0
        this.lslVal = Math.round(response.data.lsl * 10000) / 10000.0
        this.drawChartArea()
      }
    },
    /**
     * 차트 draw
     */
    drawChartArea () {
      var convertFloat = (value) => {
        return typeof value === 'string' ? parseFloat(value) : value
      }
      const uslVal = convertFloat(this.uslVal)
      const uclVal = convertFloat(this.uclVal)
      const meanVal = convertFloat(this.meanVal)
      const lclVal = convertFloat(this.lclVal)
      const lslVal = convertFloat(this.lslVal)

      let traces = []
      let paramValueVisible = false
      this.chartData.forEach(trace => {
        if (trace.x.length > 2) paramValueVisible = true
        if (!paramValueVisible) {
          trace.type = 'scatter'
          trace.mode = 'markers'
        } else {
          trace.hovertemplate = '<b>Sample Time:</b> %{x}<br><b>Lot ID:</b> %{text.lotId}<br><b>Value:</b> %{y:,}<br><b>Step Run Time:</b> %{text.stepRunTime}<extra></extra>'
        }
        trace.x = trace.x.map(element => Dayjs(element, 'YYYY-MM-DD HH:mm:ss.SSS').toDate())
        // trace.visible = paramValueVisible
        trace.name = 'Value'
        trace.showlegend = true
        traces.push(trace)
      })
      // let traces = [
      //   {
      //     x: this.chartData.x.map(element => Dayjs(element, 'YYYY-MM-DD HH:mm:ss.SSS').toDate()),
      //     y: this.chartData.y,
      //     visible: this.chartData.x.length > 1,
      //     hovertemplate: '<b>Sample Time:</b> %{x}<br><b>Lot ID:</b> %{text.lotId}<br><b>Value:</b> %{y:,}<br><b>Step Run Time:</b> %{text.stepRunTime}<extra></extra>',
      //     text: this.chartData.text,
      //     name: 'Value',
      //     showlegend: true
      //   }
      // ]
      let layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        hoverlabel: {
          align: 'left'
        },
        xaxis: {
          tickformat: '%m/%d %H:%M:%S'
        },
        shapes: [
          {
            type: 'line',
            xref: 'paper',
            x0: 0,
            x1: 1,
            yref: 'y',
            y0: uslVal,
            y1: uslVal,
            line: { color: 'red', width: 1 },
            visible: uslVal !== null
          }, {
            type: 'line',
            xref: 'paper',
            x0: 0,
            x1: 1,
            yref: 'y',
            y0: uclVal,
            y1: uclVal,
            line: { color: 'orange', width: 1 },
            visible: uclVal !== null
          }, {
            type: 'line',
            xref: 'paper',
            x0: 0,
            x1: 1,
            yref: 'y',
            y0: lclVal,
            y1: lclVal,
            line: { color: 'orange', width: 1 },
            visible: lclVal !== null
          }, {
            type: 'line',
            xref: 'paper',
            x0: 0,
            x1: 1,
            yref: 'y',
            y0: lslVal,
            y1: lslVal,
            line: { color: 'red', width: 1 },
            visible: lslVal !== null
          }
        ],
        annotations: [
          {
            xref: 'paper',
            x: 1,
            xanchor: 'left',
            yref: 'y',
            y: uslVal,
            text: 'USL: ' + uslVal,
            showarrow: false,
            visible: uslVal !== null
          }, {
            xref: 'paper',
            x: 1,
            xanchor: 'left',
            yref: 'y',
            y: uclVal,
            text: 'UCL: ' + uclVal,
            showarrow: false,
            visible: uclVal !== null
          }, {
            xref: 'paper',
            x: 1,
            xanchor: 'left',
            yref: 'y',
            y: lclVal,
            text: 'LCL: ' + lclVal,
            showarrow: false,
            visible: lclVal !== null
          }, {
            xref: 'paper',
            x: 1,
            xanchor: 'left',
            yref: 'y',
            y: lslVal,
            text: 'LSL: ' + lslVal,
            showarrow: false,
            visible: lslVal !== null
          }
        ]
      }
      if (meanVal !== null) {
        layout.shapes.push({
          type: 'line',
          xref: 'paper',
          x0: 0,
          x1: 1,
          yref: 'y',
          y0: meanVal,
          y1: meanVal,
          line: { color: 'yellowgreen', width: 1 }
        })
        layout.annotations.push({
          xref: 'paper',
          x: 1,
          xanchor: 'left',
          yref: 'y',
          y: meanVal,
          text: 'Mean: ' + meanVal,
          showarrow: false
        })
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true,
        edits: { shapePosition: true }
      }
      BriqueChart.newPlot('setPointChart', traces, layout, config).then(() => {
        document.querySelector('#setPointChart').on('plotly_relayout', (event) => {
          if (event.recursive) return
          if (this.uslVal !== null && this.uclVal !== null && this.lclVal !== null && this.lslVal !== null) {
            let chart = document.querySelector('#setPointChart')
            let shapes = chart.layout.shapes
            let annotations = chart.layout.annotations
            shapes[0].x0 = shapes[1].x0 = shapes[2].x0 = shapes[3].x0 = 0
            shapes[0].x1 = shapes[1].x1 = shapes[2].x1 = shapes[3].x1 = 1
            this.uslVal = shapes[0].y0 = shapes[0].y1 = annotations[0].y = Math.round(shapes[0].y1 * 10000) / 10000.0
            this.uclVal = shapes[1].y0 = shapes[1].y1 = annotations[1].y = Math.round(shapes[1].y1 * 10000) / 10000.0
            this.lclVal = shapes[2].y0 = shapes[2].y1 = annotations[2].y = Math.round(shapes[2].y1 * 10000) / 10000.0
            this.lslVal = shapes[3].y0 = shapes[3].y1 = annotations[3].y = Math.round(shapes[3].y1 * 10000) / 10000.0
            annotations[0].text = 'USL: ' + annotations[0].y
            annotations[1].text = 'UCL: ' + annotations[1].y
            annotations[2].text = 'LCL: ' + annotations[2].y
            annotations[3].text = 'LSL: ' + annotations[3].y
            if (shapes.length > 4) {
              shapes[4].x0 = 0
              shapes[4].x1 = 1
              shapes[4].y0 = shapes[4].y1 = annotations[4].y = this.meanVal
            }
            BriqueChart.setYMinMax('setPointChart', chart.data, chart.layout)
            BriqueChart.relayout('setPointChart', { recursive: true, shapes, annotations })
          }
        })
      })

      // let yMin = 0
      // let yMax = 100
      // let margin = 0
      // yMax = Math.max(...yValues)
      // yMin = Math.min(...yValues)
      // margin = (yMax - yMin) * 0.2
      // this.yMin = yMin - margin
      // this.yMax = yMax + margin
    },
    /**
     * Chart Alarm Line Annotation Draw
     */
    // drawChartAnnotation () {
    //   // var convertFloat = (value) => {
    //   //   return typeof value === 'string' ? parseFloat(value) : value
    //   // }
    //   // const uslVal = convertFloat(this.uslVal)
    //   // const uclVal = convertFloat(this.uclVal)
    //   // const meanVal = convertFloat(this.meanVal)
    //   // const lclVal = convertFloat(this.lclVal)
    //   // const lslVal = convertFloat(this.lslVal)
    //   // // const textGap = 0.02
    //   // var xValues = this.chartData.map(function (o) { return o.sampleTime })
    //   // const xStartValue = Math.min(...xValues)
    //   // const xEndVal = Math.max(...xValues)
    //   // if (!this.annotations) {
    //   //   const slSty = { 'fill': '#ff0000', 'stroke': '#ff0000' }
    //   //   const clSty = { 'fill': '#ffa500', 'stroke': '#ffa500' }
    //   //   const meanSty = { 'fill': '#01A9DB', 'stroke': '#01A9DB' }
    //   //   this.uslLine.style = slSty
    //   //   this.uslLine.name = 'USL'
    //   //   this.annotationItems.push(this.uslLine)
    //   //   // this.annotationItems.push(this.uslText)
    //   //   this.uclLine.style = clSty
    //   //   this.uclLine.name = 'UCL'
    //   //   this.annotationItems.push(this.uclLine)
    //   //   // this.annotationItems.push(this.uclText)
    //   //   this.mean.style = meanSty
    //   //   this.mean.name = 'Mean'
    //   //   this.annotationItems.push(this.mean)
    //   //   // this.annotationItems.push(this.meanText)
    //   //   this.lclLine.style = clSty
    //   //   this.lclLine.name = 'LCL'
    //   //   this.annotationItems.push(this.lclLine)
    //   //   // this.annotationItems.push(this.lclText)
    //   //   this.lslLine.style = slSty
    //   //   this.lslLine.name = 'LSL'
    //   //   this.annotationItems.push(this.lslLine)
    //   //   // this.annotationItems.push(this.lslText)

    //   //   this.annotations = new EditableAnnotationLayer(this.setPointChart, this.annotationItems)
    //   //   this._bindEditableEvent()
    //   // }
    //   // for (let i = 0; i < this.annotations.items.length; i++) {
    //   //   var value; var name
    //   //   // if (i % 2 === 0) {
    //   //   name = this.annotations.items[i].name
    //   //   switch (name) {
    //   //     case 'USL':
    //   //       value = uslVal
    //   //       break
    //   //     case 'UCL':
    //   //       value = uclVal
    //   //       break
    //   //     case 'Mean':
    //   //       value = meanVal
    //   //       break
    //   //     case 'LCL':
    //   //       value = lclVal
    //   //       break
    //   //     case 'LSL':
    //   //       value = lslVal
    //   //       break
    //   //     default:
    //   //       value = 0
    //   //       break
    //   //   }
    //   //   this.annotations.items[i].start = { x: xStartValue, y: value }
    //   //   this.annotations.items[i].end = { x: xEndVal, y: value }
    //   //   //
    //   //   this.annotations.items[i].content = name.concat(' : ', Math.round(value * 10000) / 10000.0)
    //   //   // } else {
    //   //   //   this.annotations.items[i].text = name.concat(' : ', Math.round(value * 10000) / 10000.0)
    //   //   //   this.annotations.items[i].point = { x: xStartValue, y: value }
    //   //   // }
    //   // }
    // },
    /**
     * textbox 데이터 변경 이벤트 (Mean, Stdev, USL, UCL, LCL, LSL)
     */
    valueChange () {
      // this.drawChartAnnotation()

      // test 필요
      // var yValues = this.chartData.map(function (o) { return o.paramValue })
      // yValues.push(this.uslVal)
      // yValues.push(this.uclVal)
      // yValues.push(this.lclVal)
      // yValues.push(this.lslVal)
      this.drawChartArea()
    },
    /**
     * Detection Model 조회 (선택된 row)
     */
    async loadChartData () {
      const item = this.selectedModelData
      if (item === null) { return }
      if (item.briqueGridCud && item.briqueGridCud === 'C') { return }

      const payload = {
        fab: item.fab,
        eqpId: item.eqpId,
        moduleId: item.moduleId,
        paramName: item.paramName,
        recipeId: item.recipeId,
        stepId: item.stepId,
        uvaType: 'setpoint',
        modelType: 'uva'
      }
      await API.Model.getSetPointModel(payload, this.callback)
    },
    /**
     * Detection Model 조회 callback
     * @param {Object} item Detection Model 조회 결과
     */
    callback (item) {
      this.uslVal = Math.round(item.usl * 10000) / 10000.0
      this.uclVal = Math.round(item.ucl * 10000) / 10000.0
      this.lclVal = Math.round(item.lcl * 10000) / 10000.0
      this.lslVal = Math.round(item.lsl * 10000) / 10000.0
      this.meanVal = null
      this.stdevVal = null
      this.settlingTime = this.selectedModelData.settlingTime
      this.activationTime = this.selectedModelData.activationTime

      // this.chartData = item.chartValueList
      this.chartData = item.setPointDetectionChart

      // chartdata bind 지연으로
      setTimeout(() => {
        // this.drawChartSeries(false)
        // this.chartType = 'Scatter'
        // this.drawChartAnnotation()
        // var yValues = this.chartData.y
        // yValues.push(this.uslVal)
        // yValues.push(this.uclVal)
        // yValues.push(this.lclVal)
        // yValues.push(this.lslVal)
        this.drawChartArea()
      }, 30)
    },
    /**
     * Save Validation
     * @returns {Boolean} validation 성공 여부
     */
    isValidSaveData () {
      if (this.chartData == null || !this.chartData.length) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Chart Data']))
        return false
      }

      var isValid = function (that, value, name) {
        if (value == null || value === '' || !value > 0) {
          that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [name]))
          return false
        }
        return true
      }

      // var isValidSig = function (that, value, name) {
      //   if (value == null || value === '' || !(value > 0)) {
      //     that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [name]))
      //     return false
      //   }
      //   return true
      // }

      return !(
        !isValid(this, this.uslVal, 'USL') ||
        !isValid(this, this.uclVal, 'UCL') ||
        // !isValid(this, this.meanVal, 'Mean') ||
        // !isValid(this, this.stdevVal, 'Stdev') ||
        !isValid(this, this.lclVal, 'LCL') ||
        !isValid(this, this.lslVal, 'LSL') ||
        !isValid(this, this.settlingTime.toString(), 'Settling Time') ||
        !isValid(this, this.activationTime.toString(), 'Activation Time')
      )
    },
    /**
     * Detection Model 저장
     */
    async saveData () {
      if (!this.isValidSaveData()) {
        return
      }
      this.tmpSelectedModelData = this.selectedModelData
      const payload = {
        modelType: 'UVA',
        dataList: [{
          fab: this.selectedModelData.fab,
          eqpId: this.selectedModelData.eqpId,
          moduleId: this.selectedModelData.moduleId,
          paramName: this.selectedModelData.paramName,
          recipeId: this.selectedModelData.recipeId,
          stepId: this.selectedModelData.stepId,
          uvaType: this.selectedModelData.uvaType,
          uslVal: this.uslVal,
          uclVal: this.uclVal,
          lclVal: this.lclVal,
          lslVal: this.lslVal,
          settlingTime: Number(this.settlingTime),
          activationTime: Number(this.activationTime)
        }]
      }

      const response = await API.Model.putSetPointModel(payload)
      if (response.status === 200 && response.data) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
        // this.searchModel()
        this.selectedModelData = this.tmpSelectedModelData
      }
    },
    /**
     * Select Lot Modal 닫기
     * @param {Boolean} value Modal 표시 여부
     */
    resetModalData (value) {
      this.selectLotsModal.visible = value
    },
    /**
     * Select Lot Modal 열기
     */
    showLotsModal () {
      this.selectLotsModal.visible = this.selectedModelData !== null && Object.keys(this.selectedModelData).length > 0
      if (!this.selectLotsModal.visible) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Model']))
      }
    },
    /**
     * Modal Apply Lot callback
     * @param {Array} list 선택된 lot 목록 배열
     */
    async applyLots (list) {
      this.selectedLots = list

      const payload = {
        modelType: 'UVA',
        dataList: {
          paramName: this.selectedModelData.paramName,
          stepId: this.selectedModelData.stepId,
          lotsList: this.selectedLots
        }
      }

      const response = await API.Model.getSetPointDatas(payload)
      if (response.status === 200 && response.data) {
        if (this.annotations) {
          this.annotations.items.splice(0, this.annotations.items.length)
          // this.toggleDragEventBinding(false)
          this.annotations = null
          this.annotationItems = []
        }
        this.meanVal = null
        this.stdevVal = null
        this.uslVal = null
        this.uclVal = null
        this.lclVal = null
        this.lslVal = null
        // this.chartData = response.data.lotsList

        this.orgLotsList = response.data.lotsList
        this.lotsList = this.remakeLotsList(response.data.lotsList)
        this.orgChartData = response.data.setPointDetectionChart
        this.chartData = this.remakeChartData(response.data.setPointDetectionChart)

        // this.drawChartSeries(true)
        // this.chartType = 'LineSymbols'
        // var yValues = this.chartData.y
        // this.drawChartArea()

        if (this.autoSpecFlag) {
          this.calcAutoSpec()
          this.autoSpecFlag = false
        } else {
          this.drawChartArea()
        }
      }
    },
    /**
     * Modal Auto Spec callback
     */
    autoSpecLots () {
      this.autoSpecFlag = true
    },
    /**
     * Detection Model row selection event
     * @param {*} row Detection Model row data
     */
    setModelProps (row) {
      this.selectedModelData = row
      this.selectedModelCondData = {}
      this.selectedLots = []
      this.chartData = []
      this.orgChartData = []
      this.lotsList = []
      this.orgLotsList = []
      this.loadChartData()
    },
    clearData () {
      this.selectedModelData = {}
      this.selectedModelCondData = {}
      this.selectedLots = []
      this.chartData = []
      this.orgChartData = []
      this.lotsList = []
      this.orgLotsList = []
      this.meanVal = null // Mean value
      this.stdevVal = null // Stdev value
      this.uslVal = null // USL value
      this.uslSig = 6 // USL Sigma value
      this.uclVal = null // UCL value
      this.uclSig = 3 // UCL Sigma value
      this.lclVal = null // LCL value
      this.lclSig = 3 // LCL Sigma value
      this.lslVal = null // LSL value
      this.lslSig = 6 // LSL Sigma value
      this.yMin = null // chart y축 Min value
      this.yMax = null // chart y축 Max value
      this.clearChart()
    },
    clearChart () {
      // NOTE: 데이터 초기화와 drawChart를 같은 함수 안에서 수행하면
      // 이전 데이터를 참조하여 차트를 그리는 현상이 있어서 분리하여 실행함
      // 올바른 해결책인지는 추후 확인 필요...
      this.drawChartArea()
    },
    /**
     * Detection Model Condition row selection event
     * @param {*} row
     */
    setModelConditionProps (row) {
      this.selectedModelCondData = row
      // this.selectedLots = []
      // this.chartData = []
      // this.loadChartData()
    },

    // ======================= Chart관련 Method Start =========================
    /**
     * Date Format 변경
     * @param {Date} date Date
     * @returns {String} formatted date string
     */
    formatDate (date) {
      String.prototype.string = function (len) { var s = ''; var i = 0; while (i++ < len) { s += this } return s }
      String.prototype.zf = function (len) { return '0'.string(len - this.length) + this }
      let dateTimeFmt = (date.getMonth() + 1) + '/' + date.getDate().toString().zf(2) + ' ' + date.getHours().toString().zf(2) + ':' + date.getMinutes().toString().zf(2) + ':' + date.getSeconds().toString().zf(2)
      return dateTimeFmt
    },
    /**
     * Settling Time 변경 event
     */
    settlingTimeChange (val) {
      if (this.orgChartData.length > 0) {
        this.lotsList = this.remakeLotsList(this.orgLotsList)
        this.chartData = this.remakeChartData(this.orgChartData)
      }
      // var yValues = this.chartData.y
      // yValues.push(this.uslVal)
      // yValues.push(this.uclVal)
      // yValues.push(this.lclVal)
      // yValues.push(this.lslVal)
      this.drawChartArea()
    },
    /**
     * Activation Time 변경 event
     */
    activationTimeChange (val) {
      if (this.orgChartData.length > 0) {
        this.lotsList = this.remakeLotsList(this.orgLotsList)
        this.chartData = this.remakeChartData(this.orgChartData)
      }
      // var yValues = this.chartData.y
      // yValues.push(this.uslVal)
      // yValues.push(this.uclVal)
      // yValues.push(this.lclVal)
      // yValues.push(this.lslVal)
      this.drawChartArea()
    },
    /**
     * Chart Data 재구성
     * @param {*} orgChartData chart data
     * @returns {Array} 재구성된 chart data
     */
    remakeChartData (orgChartData) {
      let traces = []
      if (this.settlingTime !== null && this.activationTime !== null) {
        for (let trace of orgChartData) {
          let x = []
          let y = []
          let text = []
          for (let i in trace.text) {
            if (trace.text[i].stepRunTime >= this.settlingTime &&
              (Number(this.activationTime) === -1 || Number(this.activationTime) === 0 || trace.text[i].stepRunTime < (this.settlingTime + this.activationTime))) {
              x.push(trace.x[i])
              y.push(trace.y[i])
              text.push(trace.text[i])
            }
          }
          let newTrace = _.clone(trace)
          newTrace.x = x
          newTrace.y = y
          newTrace.text = text
          traces.push(newTrace)
        }
        // return chartData.length > 0 ? chartData : orgChartData
        return traces
      } else {
        return orgChartData
      }
      // let chartData = []
      // if (this.settlingTime !== null && this.activationTime !== null) {
      //   for (let i in orgChartData) {
      //     if (orgChartData[i].stepRunTime >= this.settlingTime &&
      //       (Number(this.activationTime) === -1 || Number(this.activationTime) === 0 || orgChartData[i].stepRunTime < (this.settlingTime + this.activationTime))) {
      //       chartData.push(orgChartData[i])
      //     }
      //   }
      //   // return chartData.length > 0 ? chartData : orgChartData
      //   return chartData
      // } else {
      //   return orgChartData
      // }
    },
    /**
     * Lots List 재구성
     * @param {*} orgLotsList lots list
     * @returns {Array} 재구성된 lots list
     */
    remakeLotsList (orgLotsList) {
      let lotsList = []
      if (this.settlingTime !== null && this.activationTime !== null) {
        for (let i in orgLotsList) {
          if (orgLotsList[i].stepRunTime >= this.settlingTime &&
            (Number(this.activationTime) === -1 || Number(this.activationTime) === 0 || orgLotsList[i].stepRunTime < (this.settlingTime + this.activationTime))) {
            lotsList.push(orgLotsList[i])
          }
        }
        return lotsList
      } else {
        return orgLotsList
      }
    },
    /**
     * 선택된 Detection Model이 있는지 여부 체크
     * @returns {Boolean}
     * Button 및 Textbox의 활성화를 제어합니다.
     */
    hasSelectedModelData () {
      if (this.selectedModelData === null) {
        return false
      } else if (Object.keys(this.selectedModelData).length === 0) {
        return false
      } else if (this.selectedModelData.briqueGridCud && this.selectedModelData.briqueGridCud === 'C') {
        return false
      } else {
        return true
      }
    }
    // ======================= Chart관련 Method End =========================
  },
  data () {
    return {
      autoSpecFlag: false, // Auto Spec 실행하는지 여부
      annotations: null, // wijmo chart AnnotationLayer
      annotationItems: [], // Chart Annotation data 배열
      meanVal: null, // Mean value
      stdevVal: null, // Stdev value
      uslVal: null, // USL value
      uslSig: 6, // USL Sigma value
      uclVal: null, // UCL value
      uclSig: 3, // UCL Sigma value
      lclVal: null, // LCL value
      lclSig: 3, // LCL Sigma value
      lslVal: null, // LSL value
      lslSig: 6, // LSL Sigma value
      yMin: null, // chart y축 Min value
      yMax: null, // chart y축 Max value
      chartData: [], // chart data
      orgChartData: [], // chart data
      lotsList: [], // lot data list
      orgLotsList: [], // lot data list
      selectLotsModal: {
        visible: false
      }, // Select Lot Modal 표시 여부
      selectedLots: [], // Select Lot Modal에서 선택된 LOT 배열
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색된 EQP Tree node
      selectedModelData: {
        paramName: '',
        recipeId: '',
        stepId: ''
      }, // 선택된 Detection Model
      selectedModelCondData: {}, // 선택된 Detection Model Condition
      tmpSelectedModelData: {}, // 선택된 Detection Model
      settlingTime: null, // Settling Time value
      activationTime: null, // Activation Time value
      maxStepRunTime: null // Max Step Run time value
      // chartType: null // Chart Type
    }
  }
}
